/** * @author FightFastest * @date 30/12/2021 上午 9:25 */

<script>
export default {
	name: 'advance',
	data() {
		return {
			advanceTable: []
		}
	},
	props: {
		info: {
			type: Array,
			default: () => []
		}
	},
	mounted() {
		let advanceTable = []
		this.info.forEach(res => {
			let curRow = {}
			curRow.className = res.className
			curRow.progressiveRank = res.progressiveRank
			res.examInfoDTOS.forEach(resp => {
				curRow[`${resp.examId}avgScore`] = resp.avgScore
				curRow[`${resp.examId}rank`] = resp.rank
			})
			advanceTable.push(curRow)
		})
		this.advanceTable = advanceTable
	},
	render(createElement) {
		return createElement(
			'el-table',
			{
				props: {
					data: this.advanceTable,
					border: true,
					strip:true
				}
			},
			[
				createElement('el-table-column', {
					props: {
						prop: `className`,
						label: '年级',
						align: 'center'
					}
				}),
				...this.columnInfo(createElement),
				createElement('el-table-column', {
					props: {
						prop: `progressiveRank`,
						label: '进步',
						align: 'center'
					}
				})
			]
		)
	},
	methods: {
		columnInfo(createElement) {
			let resColumn = []
			this.info[0].examInfoDTOS.forEach(res => {
				resColumn.push(
					createElement('el-table-column', {
						props: {
							prop: `${res.examId}avgScore`,
							label: res.beginTime,
							align: 'center'
						}
					})
				)
				resColumn.push(
					createElement('el-table-column', {
						props: {
							prop: `${res.examId}rank`,
							label: '名次',
							align: 'center'
						}
					})
				)
			})
			return resColumn
		}
	}
}
</script>

<style scoped lang="less"></style>
